import { useEffect, useRef } from 'react';
import { ActivityIndicator, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';

import { colors, Text } from '@pletly/ui';
import { useMediaSource } from './useMediaSource';
import { MediaPlayerProps } from './types';

export const MediaPlayer = ({ style, source, autoPlay, playerVisible }: MediaPlayerProps) => {
	const { t } = useTranslation();
	const videoRef = useRef<HTMLVideoElement>(null);
	const mediaSource = useMediaSource(source);

	useEffect(() => {
		if (!videoRef.current || playerVisible) {
			return;
		}

		void videoRef.current.pause();
	}, [playerVisible]);

	if (mediaSource.uri === undefined) {
		return <ActivityIndicator size="large" style={styles.loader} color={colors.primary} />;
	}

	if (mediaSource.uri === null) {
		return <Text>{t('validations.error')}</Text>;
	}

	return (
		// skipcq: JS-0754
		<video
			controls
			ref={videoRef}
			src={mediaSource.uri}
			autoPlay={playerVisible && autoPlay}
			style={StyleSheet.flatten([styles.root, styles.webPlayer, style])}
		/>
	);
};

const styles = StyleSheet.create({
	root: {
		justifyContent: 'center',
	},
	loader: { margin: 'auto' },
	webPlayer: {
		position: 'relative',
	},
});
